import React, { FC, memo } from 'react';
import MenuItem, { MenuItemProps } from '@mui/material/MenuItem';
import { Currency } from '../../api/currencies/types';

type CurrencyMenuItemProps = MenuItemProps & {
    currency: Currency;
};

/**
 * Standardized currency dropdown option for MUI Select.
 * Shows code (bold, left) and symbol (faded, right).
 */
const CurrencyMenuItem: FC<CurrencyMenuItemProps> = ({ currency, ...menuItemProps }) => {
    return (
        <MenuItem
            {...menuItemProps}
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                '&:hover': { backgroundColor: '#f3f4f6' },
                '&.Mui-selected': { backgroundColor: '#f3f4f6' },
                ...((menuItemProps.sx as any) || {})
            }}
        >
            <span style={{ fontWeight: 600, minWidth: 60 }}>{currency?.code}</span>
            <span style={{ opacity: 0.65 }}>{currency?.symbol}</span>
        </MenuItem>
    );
};

/**
 * Render option for AutocompleteByOptionId currency dropdowns.
 * Use as: renderOption={renderCurrencyOption}
 */
export const renderCurrencyOption = (option: Currency | any) => (
    <span style={{ display: 'flex', justifyContent: 'space-between', width: 100 }}>
        <span style={{ fontWeight: 600 }}>{option?.code}</span>
        <span style={{ opacity: 0.65 }}>{option?.symbol}</span>
    </span>
);

/**
 * Format a currency for display in a Select's renderValue or text display.
 * Returns "USD $" format.
 */
export const formatCurrencyDisplay = (currency: Currency | any): string => {
    if (!currency) return '';
    return `${currency.code || ''} ${currency.symbol || ''}`.trim();
};

export default memo(CurrencyMenuItem);
